import React from "react";
export default ({ fill, children, viewBox = "0 0 24 24", width="24", height="24", ...props }) => (
  <svg viewBox={viewBox} fill={fill || 'currentColor'} width={width} height={height} {...props}>
    <rect width={width || viewBox.split(' ')[2]} height={height || viewBox.split(' ')[3]} fill="transparent" />
    {children}
  </svg>
)